
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DlgGroupNew from '@/modules/admin/groups/_components/DlgGroupNew.vue';
  import DlgGroupDelete from '@/modules/admin/groups/_components/DlgGroupDelete.vue';
  import DlgGroupUpdate from '@/modules/admin/groups/_components/DlgGroupUpdate.vue';

  @Component({
    components: {DlgGroupUpdate, DlgGroupDelete, DlgGroupNew, Card},
  })
  export default class VGroups extends Vue {
    @Action('admin/groups/read') private read!: () => Promise<void>;
    @Getter('admin/groups/all') private groups!: any;

    private headers: any = [
      {
        text: 'Titel',
        align: 'left',
        value: 'title',
      },
      {
        text: '# Mitglieder',
        align: 'left',
        value: 'members',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private async mounted() {
      this.loading = true;
      await this.read();
      this.loading = false;
    }
  }
